define('presentation/common/window/windowControl',["settings/settings"], function() {
    const ANDROID_APP_URL = "https://play.google.com/store/apps/details?id=com.patlive.app";
    const IOS_APP_URL = "https://apps.apple.com/app/patlive-flex/id6747596738";
    const TCR_URL = "https://www.campaignregistry.com/";
    const ONBOARDING_LIVE_RECEPTIONIST_FORM_URL = "https://patlive.com/onboarding";
    const ONBOARDING_WEB_CHAT_FORM_URL = "https://patlive.formstack.com/forms/webchat";
    const ONBOARDING_OUTBOUND_CALLING_FORM_URL = "https://patlive.formstack.com/forms/outbound_customers";
    const ONBOARDING_APPOINTMENT_URL = "https://hello.patlive.com/meetings/patlive/onboarding";

    return {
        openNewWindow: (/** @type { string | URL } */ url, /** @type { string } */ target) => {
            if (target === undefined) {
                target = "_blank";
            }
            window.open(url, target);
        },
        setConfirmationMessageOnNavigateAway: (/** @type { any } */ message) => {
            window.onbeforeunload = () => message;
        },
        clearConfirmationMessageOnNavigateAway: () => {
            window.onbeforeunload = null;
        },
        getBaseUrl: () => window.location.protocol + "//" + window.location.host,
        getCouchBaseUrl: () => {
            const settings = require('settings/settings');
            return settings.couchDatabaseUrl;
        },
        getFrontendBaseUrl: () => {
            const settings = require('settings/settings');
            return window.location.protocol + "//" + settings.frontendDomain;
        },
        get openContactUs() {
            return (/** @type { string } */ target) => {
                const contactUrl = this.getFrontendBaseUrl() + '/contact';
                this.openNewWindow(contactUrl, target);
            };
        },
        get openFAQPage() {
            return (/** @type { string } */ target) => {
                const termsUrl = this.getFrontendBaseUrl() + '/faq';
                this.openNewWindow(termsUrl, target);
            };
        },
        get openHomePage() {
            return (/** @type { string } */ target) => {
                const homeUrl = this.getFrontendBaseUrl();
                this.openNewWindow(homeUrl, target);
            };
        },
        get openIosAppUrl() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(IOS_APP_URL, target);
            };
        },
        get openAndroidAppUrl() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(ANDROID_APP_URL, target);
            };
        },
        get openTcrUrl() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(TCR_URL, target);
            };
        },
        get openTermsOfAgreement() {
            return (/** @type { string } */ target) => {
                const termsUrl = this.getFrontendBaseUrl() + '/terms-of-use';
                this.openNewWindow(termsUrl, target);
            };
        },
        get onOpenOnboardingAppointment() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(ONBOARDING_APPOINTMENT_URL, target);
            };
        },
        get getOnboardingAppointmentUrl() {
            return () => ONBOARDING_APPOINTMENT_URL;
        },
        get onOpenOnboardingLiveReceptionistForm() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(ONBOARDING_LIVE_RECEPTIONIST_FORM_URL, target);
            };
        },
        get onOpenOnboardingWebChatForm() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(ONBOARDING_WEB_CHAT_FORM_URL, target);
            };
        },
        get onOpenOnboardingOutboundCallingForm() {
            return (/** @type { string } */ target) => {
                this.openNewWindow(ONBOARDING_OUTBOUND_CALLING_FORM_URL, target);
            };
        },
        get openExternalUrl() {
            return (/** @type { string } */ url) => {
                const httpsRegex = new RegExp(/^https:\/\//i); // check for https:// prefixes (case insensitive)

                if (httpsRegex.test(url)) {
                    this.openNewWindow(url);
                    return;
                }

                const httpRegex = new RegExp(/^http:\/\//i); // check for http:// prefixes (case insensitive)

                const formattedUrl = httpRegex.test(url) ? `https://${url.slice(7)}` : `https://${url}`;
                this.openNewWindow(formattedUrl);
            };
        }
    };
});
